<template>
    <div class="layout-article">
        <div v-if="!loading && article">

              <slot name="header">
                  <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header" v-bind:class="{'has-video': !!article.videoEmbed}">
                    <div class="uk-light uk-container uk-container-small uk-text-center">

                        <router-link :to="article.articlePage.link" v-if="article.articlePage" class="text-green"><label>{{article.articlePage.menuTitle}}</label></router-link>
                        <h1 class="uk-margin-small-top">{{article.title}}</h1>

                        <slot name="summary">
                            <p class="uk-text-lead" v-if="article.summary">{{article.summary}}</p>
                        </slot>

                    </div>
                  </div>
              </slot>
              <!-- <div class="uk-section uk-section-small uk-text-center uk-background-light uk-background-cover uk-background-fixed uk-background-blend-multiply uk-padding hero page-header" uk-height-viewport>
                  <div class="uk-light uk-position-center uk-width-2-3@l uk-width-4-5@m hero-content content-max">

                      <p class="uk-text-lead">{{summary}}</p>

                      <a href="#" v-for="btn in cta" class="uk-button theme-button" :class="btn.class">{{btn.title}}</a>
                  </div>
              </div> -->

              <slot>
                  <div class="uk-section uk-section-medium uk-background-white">
                      <div class="uk-container uk-container-small">

                          <div class="video flex-video widescreen" v-if="article.videoEmbed">
                              <div v-html="article.videoEmbed"></div>
                          </div>

                          <div class="content" v-html="article.content"></div>

                          <img :src="article.image.large" v-if="article.image && article.image.large" />
                      </div>
                  </div>

              </slot>

              <!--<div class="uk-section uk-section-medium uk-background-muted uk-light" v-if="readPageByURL.secondaryContent">
                  <div class="uk-container uk-container-small">
                      <div class="content" v-html="readPageByURL.secondaryContent"></div>
                  </div>
              </div> -->

      </div>

    </div>
</template>

<script>
// import ProjectCard from '../ProjectCard.vue'
// import FloatingBadge  from '../../components/FloatingBadge.vue'
import gql from 'graphql-tag'

// GraphQL query
const readArticleQuery = gql`
    query($urlSegment: String!) {
      readOneArticle(filter: { urlSegment: { eq: $urlSegment }}){
        id
        summary
        content
        title
        link
        image {
            large
        }
        videoEmbed
        articlePage {
            menuTitle
            link
        }
      }
    }
`

export default {
    name: 'ArticlePage_Article',
    inject: ['state'],
    data() {
        return {
            article: {}
        }
    },
    components: {
        // ProjectCard,
        // FloatingBadge
    },
    apollo: {
        article: {
            // GraphQL query
            query: readArticleQuery,
            variables() {
                return {
                    urlSegment: this.$route.params.articleId
                }
            },
            update(data) {
                this.state.setMetaTitle(data.readOneArticle.title)
                return data.readOneArticle
            },
            loadingKey: 'loading'
        }
    }
}
</script>
